import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useMediaQuery, useTheme } from '@mui/material';
import { TabInt } from '../../interfaces';
import { important } from '../../utils/global/helper';

interface TabPanelProps {
  children: React.ReactNode;
  index: number;
  value: number;
  noTopMargin?: boolean;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, noTopMargin } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className="tab-content"
      style={noTopMargin ? { marginTop: 0 } : undefined}>
      {value === index && (
        <Box mt={noTopMargin ? 0 : 3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

interface Props {
  tabs: TabInt[];
  currentTab: number;
  changeTab: (tab: number) => void;
  noTopMargin?: boolean;
  hideWhenOnlyOneTab?: boolean;
}

export default function TabBar({
  tabs,
  currentTab,
  changeTab,
  noTopMargin,
  hideWhenOnlyOneTab,
}: Props) {
  const theme = useTheme();
  const isMdOrLarger = useMediaQuery(theme.breakpoints.up('md'));
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    changeTab(newValue);
  };

  const filteredTabs = tabs?.filter(tab => !tab.hidden);

  const hideTabBar = hideWhenOnlyOneTab && filteredTabs.length === 1;

  return (
    <Box sx={{ width: '100%' }}>
      {!hideTabBar && (
        <Box
          sx={{
            borderBottom: 1,
            borderColor: '#EDEEEF',
            '.MuiTabs-scroller': {
              overflow: important('auto'),
            },
          }}>
          <Tabs
            variant={isMdOrLarger ? 'standard' : 'fullWidth'}
            value={currentTab}
            onChange={handleChange}
            aria-label="tab bar">
            {filteredTabs.map(({ label, id }, i) => (
              <Tab
                key={id || label}
                label={label}
                id={`simple-tab-${i}`}
                style={{
                  fontFamily:
                    'Montserrat, Open Sans, Helvetica, Arial, sans-serif',
                }}
                aria-controls={`simple-tabpanel-${i}`}
              />
            ))}
          </Tabs>
        </Box>
      )}
      {filteredTabs.map((tab, i) => (
        <TabPanel
          value={currentTab}
          index={i}
          key={tab.label}
          noTopMargin={noTopMargin || hideTabBar}>
          {tab.component}
        </TabPanel>
      ))}
    </Box>
  );
}
